import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../dashboardContent/config'; 
import { MailOutline, Send } from '@mui/icons-material';
import '../../StylesCSS/ContactUs.css';


const ContactUs = () => {

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/version2/api/contact`, formData);
      toast.success('Message envoyé avec succès !');
      setFormData({ firstName: '', lastName: '', email: '', subject: '', message: '' });
    } catch (error) {
      console.error(error);
      toast.error("Une erreur s'est produite.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact-page">
      <div className="contact-shell">
        <header className="contact-hero">
          <span className="contact-eyebrow">الدعم والتواصل</span>
          <h1>اتصل بنا</h1>
          <p>نحن هنا لمساعدتكم. أرسلوا رسالتكم وسيتواصل معكم فريقنا في أقرب وقت.</p>
        </header>

        <div className="contact-card">
          <h2 className="contact-card-title">
            <MailOutline aria-hidden="true" />
            إرسال رسالة
          </h2>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="contact-fields">
              <div className="contact-field">
                <label htmlFor="contact-first-name">الاسم الشخصي</label>
                <input
                  id="contact-first-name"
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact-field">
                <label htmlFor="contact-last-name">الاسم العائلي</label>
                <input
                  id="contact-last-name"
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact-field">
                <label htmlFor="contact-email">البريد الإلكتروني</label>
                <input
                  id="contact-email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact-field">
                <label htmlFor="contact-subject">الموضوع</label>
                <input
                  id="contact-subject"
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="contact-field contact-field-full">
                <label htmlFor="contact-message">مضمون الرسالة</label>
                <textarea
                  id="contact-message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="contact-actions">
              <button type="submit" disabled={loading} className="contact-submit">
                <Send aria-hidden="true" />
                {loading ? 'جار إرسال الرسالة...' : 'إرسال الرسالة'}
              </button>
            </div>
          </form>
        </div>
        <ToastContainer position="top-left" rtl />
      </div>
    </section>
  );
};

export default ContactUs;
